import {
  HeaderIconProps,
  HeaderIconWrapper,
  HeaderIconWrapperV2,
  HomeVideoCard,
  IStyles,
  ImageWrapper,
  SecondaryButton,
  StudentSubjectPopup,
  deserify,
  findOfflineUserRequestByParamsDexie,
  getDeviceType,
  getEnvConfig,
  getLocalStorage,
  getMediaBasePath,
  migrateIndexedDbData,
  pxToRem,
  pxTovW,
  setLocalStorage,
  storeOfflineAccessKeyInCache,
  useCommonServiceClientContext,
  useFeatureEnabled,
} from '@geneo2-web/shared-ui';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Switch,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../app/Context/GlobalContextProvider';
import { useAppSelector } from '../../reduxStore/reduxHooks';
import {
  HOME,
  HOMEWORK_STUDENT_DASHBOARD,
  LEARN_DASHBOARD,
  PAL_LEARN_DASHBOARD,
  PERFORMANCE_STUDENT_DASHBOARD,
  SSO_REDIRECT,
} from '../../routeHandling/RoutesNomenclature';
import { getSubjectsMap } from '../../utils/icons';
import {
  setIsLoggedInOffline,
  setSessionMode,
  setShowNameEditPopup,
  setUserInfo,
} from '../Auth/reducer/auth.slice';
import {
  setResourceRedirectionPath,
  setSelectedResourceSessionId,
} from '../Learn/reducer/learn.slice';
import ActiveHomeworkList from './components/ActiveHomeworkList';
import OngoingLessonList from './components/OngoingLessonList';
import RecommendedResourcesList from './components/RecommendedResourcesList';
import {
  setHomeSelectedBookId,
  setHomeSelectedSubjectId,
  setStudentProfileData,
  setToastInfo,
} from './reducer/homeDashboard.slice';

import { useDownloadContext } from '../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../Auth/Login/login_logout.events';
import { setActiveHomeworSessionId } from '../Homework/reducer/homework.slice';
import {
  aiHomeworkCloseEvent,
  aiHomeworkReviewCloseEvent,
} from '../Homework/utils_homework/homework.events';
import {
  aiBookCloseEvent,
  aiBookOpenEvent,
  aiChapterCloseEvent,
  aiContentCloseEvent,
  aiLessonCloseEvent,
  aiResourceCloseEvent,
  aiResourcePageCloseEvent,
  aiTopicCloseEvent,
} from '../Learn/utils_learn/learn.events';
import { setPerformanceId } from '../Performance/reducer/performance.slice';
import { aiPerformanceCloseEvent } from '../Performance/utils_performance/performance.events';
// import getDeviceType from 'libs/shared-ui/src/commonUtils/getDeviceType';
// import {} from './home.events';
import { SelectChangeEvent } from '@mui/material/Select';
import { Feature } from '@protos/school_management/school.db_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import ConfigSelector from '../OfflineScreens/Learn/components/ConfigSelector';
import { StudentLoginResponseType } from '@protos/user_management/ums.login.apis_pb';
import TextBookList from './components/TextBookList';
import { resetReportData } from '../Sidebar/Reports/reducer/report.slice';
import { isFeatureEnabled } from 'libs/shared-ui/src/commonUtils/contentLockKeyFeature';
import StudentNameEditPopup from './components/StudentNameEditPopup';
import { ALLOW_EDIT_STUDENT_NAME_FOR_SCHOOL_IDS } from './utill';
import { currentSessionMode } from '../../utils/commonUtils';
import {
  setExternalStudentId,
  setLearningMode,
} from '../Pal/reducer/pal.slice';
import HomePersonalisedJourney from '../Pal/components/HomePersonalisedJourney';
import { useFilteredLearnSubjects } from '../../utils/ssoUserHooks';
import {
  getAdaptiveLearningEnrollment,
  registerToAdaptiveLearning,
} from '../Pal/api/studentEnrollment';

export const Home = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const [selectedValue, setSelectedValue] = useState('');
  const {
    is_logged_in_offline,
    userInfo,
    isNameEditPopupShown,
    session_mode,
    sso_subject_ids,
    is_sso_user,
  } = deserify(useAppSelector((state) => state.auth));
  const { token, studentProfileId } = userInfo || {};
  const selectedSubjectId = deserify(
    useAppSelector((state) => state.home.selected_subject_id)
  );
  const { selected_book_id, student_profile_data } = deserify(
    useAppSelector((state) => state.home)
  );
  const { learningMode, externalStudentId } = deserify(
    useAppSelector((state) => state.pal)
  );
  const featureInfo = userInfo?.schoolDetails?.featuresPlanInfo;
  const isPalFeatureEnabled = useFeatureEnabled(
    featureInfo,
    Feature.PAL_FEATURE_ENABLED
  );
  const isPalMode = isPalFeatureEnabled && learningMode == 'pal';

  const {
    selected_chapter_resources,
    selected_module_lessons,
    selected_lesson_content,
    selected_resource_content,
    selected_resource_info,
  } = deserify(useAppSelector((state) => state.learn));
  const android = window.Android;
  const config = getEnvConfig();
  const learnSubjects =
    deserify(useAppSelector((state) => state.auth.userInfo?.learnSubjects)) ||
    [];
  const filteredLearnSubjects = useFilteredLearnSubjects();

  const isWhiteLabelingFeature = useFeatureEnabled(
    featureInfo,
    Feature.WHITE_LABELING
  );
  const isTextBookFeatureEnabled = isFeatureEnabled(
    featureInfo,
    Feature.SHOW_BOOK_PDFS
  );

  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedValue(event.target.value);
    // handleDownload();
  };
  const subMap = getSubjectsMap(learnSubjects);
  const styles: IStyles = {
    mainContainer: {
      padding: {
        md: `${pxTovW(100)} ${pxTovW(10)}`,
        lg: `${pxTovW(200)} ${pxTovW(240)}`,
      },
      paddingTop: isPalFeatureEnabled
        ? { md: pxTovW(400), lg: pxTovW(240) }
        : { md: pxTovW(284), lg: pxTovW(184) },
      // border: '2px solid red',
    },
    logoContainer: {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: { md: pxTovW(42) },
      paddingBottom: { xs: pxToRem(20), md: pxTovW(32) },
    },
    logo: {
      cursor: 'pointer',
      width: { xs: pxToRem(162), md: pxTovW(260) },
      height: { xs: pxToRem(46), md: pxTovW(73) },
    },
  };

  const { isOffline, isMigratingData, setIsMigratingData } =
    useDownloadContext();

  // if we access the page /home?offline=true we are forcing the frontend to open the homepage in offline mode
  const forcedOffline =
    new URLSearchParams(location.search).get('offline') === 'true';

  const isOfflineFrontend = isOffline || forcedOffline || is_logged_in_offline;

  const {
    UMSLoginAPIServiceV1ClientWithStatusCodeHandler,
    UmsUtilityAPIServiceV1ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const dispatch = useDispatch();

  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();
  const backButtonClick = async () => {
    navigate(HOME);
  };

  const { performance_id } = deserify(
    useAppSelector((state) => state.performance)
  );
  const { selected_homework_data } = deserify(
    useAppSelector((state) => state.homework)
  );
  const commonAiCloseEvents = async () => {
    await aiContentCloseEvent({
      resourceId: selected_resource_content?.parsedData.resourceId,
      pageNumber: selected_resource_info?.pageNumber,
      pageContent: selected_resource_info?.pageContent,
      isOffline: isOffline,
    });
    await aiResourcePageCloseEvent({
      resourceId: selected_resource_content?.parsedData.resourceId,
      pageNumber: selected_resource_info?.pageNumber,
      isOffline: isOffline,
    });
    await aiResourceCloseEvent({
      resourceId: selected_resource_content?.parsedData.resourceId,
      isOffline: isOffline,
    });
    await aiLessonCloseEvent({
      lessonId: selected_lesson_content?.lessonId,
      isOffline: isOffline,
    });
    await aiTopicCloseEvent({
      topicId: selected_module_lessons?.moduleId,
      isOffline: isOffline,
    });
    await aiChapterCloseEvent({
      chapterId: selected_chapter_resources?.chapterId,
      isOffline: isOffline,
    });

    await aiPerformanceCloseEvent({
      performanceId: performance_id,
      isOffline: isOffline,
    });
    dispatch(setPerformanceId(undefined));
    await aiHomeworkCloseEvent({
      homeworkId: selected_homework_data?.homeworkId,
      isOffline: isOffline,
    });
    await aiHomeworkReviewCloseEvent({
      homeworkId: selected_homework_data?.homeworkId,
      isOffline: isOffline,
    });

    //
    if (selectedSubjectId === undefined) {
      await aiBookCloseEvent({
        bookId: selected_book_id,
        isOffline: isOffline,
      });
      dispatch(setHomeSelectedBookId(undefined));
    }
    // SESSION_STORAGE.removeItem('studentLessonSessionId');
    // SESSION_STORAGE.removeItem('studentResourceSessionId');
    // SESSION_STORAGE.removeItem('studentHomeworkSessionId');
    dispatch(setActiveHomeworSessionId(undefined));
    dispatch(setSelectedResourceSessionId(undefined));
  };

  useEffect(() => {
    if (
      userInfo &&
      typeof userInfo?.schoolDetails?.schoolId == 'number' &&
      ALLOW_EDIT_STUDENT_NAME_FOR_SCHOOL_IDS.includes(
        userInfo.schoolDetails.schoolId
      ) &&
      !isNameEditPopupShown
    ) {
      dispatch(setShowNameEditPopup(true));
    }
  }, [!!userInfo]);

  useEffect(() => {
    if (location.state?.from) {
      if (location.state.from.includes(SSO_REDIRECT)) {
        if (is_sso_user && sso_subject_ids?.length && session_mode) {
          if (session_mode == 'learn') {
            dispatch(setHomeSelectedSubjectId(undefined));
            onLearnClick(true);
          } else if (session_mode == 'assess') {
            dispatch(setHomeSelectedSubjectId(undefined));
            onHomeworkClick();
          }
        }
      }
    }
  }, [location.state?.from]);

  useEffect(() => {
    if (isPalMode && userInfo?.studentProfileId && !externalStudentId) {
      fetchAndSetPalStudentId(Number(userInfo.studentProfileId));
    }
  }, [isPalMode]);

  useEffect(() => {
    dispatch(setResourceRedirectionPath(undefined));
    dispatch(resetReportData());
    commonAiCloseEvents();

    migrateIndexedDb();

    setSelectedFunction(() => backButtonClick);
    setSelectedLogoClickHandler(null);

    fetchStudentProfile();

    return () => {
      setSelectedFunction(null);
    };
  }, []);

  useEffect(() => {
    if (!isOffline && is_logged_in_offline) {
      offlineLogin();
    }
  }, [isOffline]);

  const registerPalStudent = async (userId: number) => {
    try {
      const registeredUser = await registerToAdaptiveLearning({});
      return registeredUser;
    } catch (err: any) {
      dispatch(
        setToastInfo({
          label: err.message,
          variant: 'error',
          open: true,
        })
      );
    }
  };
  const fetchAndSetPalStudentId = async (userId: number) => {
    let registeredUser: any;
    try {
      registeredUser = await getAdaptiveLearningEnrollment({});
    } catch (err: any) {
      const status = err?.status ?? err?.response?.status;
      if (status === 404) {
        registeredUser = await registerPalStudent(userId);
      } else {
        dispatch(
          setToastInfo({
            label: err.message,
            variant: 'error',
            open: true,
          })
        );
      }
    }
    if (registeredUser?.enrollment?.externalId) {
      dispatch(setExternalStudentId(registeredUser.enrollment.externalId));
    }
  };

  const migrateIndexedDb = async () => {
    if (isMigratingData) {
      return;
    }
    setIsMigratingData(true);
    try {
      await migrateIndexedDbData();
    } catch (err) {
      console.error('Error while migrating data');
    }
    setIsMigratingData(false);
  };

  const offlineLogin = async () => {
    if (!userInfo) {
      return;
    }
    const offlineUser = await findOfflineUserRequestByParamsDexie({
      username: userInfo?.userName,
    });
    if (!offlineUser) {
      return;
    }
    const res2 =
      await UmsUtilityAPIServiceV1ClientWithStatusCodeHandler.validateLoginSession(
        {
          userName: offlineUser?.username,
          verificationCode: offlineUser?.passwordHash,
          role: ProfileRolesEnum.PROFILE_ROLE_STUDENT,
        }
      );
    setLocalStorage('activeSession', res2.activeSessionId.toString());
    dispatch(setIsLoggedInOffline(false));
    // window.location.reload();
  };
  async function fetchStudentProfile() {
    try {
      const response =
        await UMSLoginAPIServiceV1ClientWithStatusCodeHandler.fetchStudentProfile(
          {
            studentProfileId: studentProfileId,
          }
        );
      const resp = response.data;
      if (resp) {
        const accessKey = resp.studentProfileId
          ? 'student-' + resp.studentProfileId.toString()
          : 'geneo';
        await storeOfflineAccessKeyInCache(accessKey);
        if (token) {
          resp.token = token;
        }
        dispatch(setUserInfo(resp));
        dispatch(setStudentProfileData(resp));
      } else {
        dispatch(setUserInfo(undefined));
        dispatch(setStudentProfileData(undefined));
      }
    } catch (err) {
      console.log(err);
      dispatch(setStudentProfileData(undefined));
    }
  }

  const navigate = useNavigate();
  const [modalState, setModalState] = useState(false);
  const [clickedFrom, setClickedFrom] = useState<
    'header' | 'learn' | undefined
  >(undefined);
  const onHomeworkClick = async () => {
    // console.log('Homework Clicked');
    navigate(HOMEWORK_STUDENT_DASHBOARD);
    await interactionEvent({
      url: 'Student_Home',
      context: 'navigation_bar',
      name: 'ASSESS',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };
  const onAnalyticsClick = async () => {
    // console.log('Homework Clicked');
    await interactionEvent({
      url: 'Student_Home',
      context: 'navigation_bar',
      name: 'PERFORMANCE',
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
    navigate(PERFORMANCE_STUDENT_DASHBOARD);
  };

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));

  // ----------------------------------------------------

  const onLearnClick = async (forcePopup?: boolean) => {
    if (typeof selectedSubjectId == 'number' && !forcePopup) {
      const route = `${
        isPalMode ? PAL_LEARN_DASHBOARD : LEARN_DASHBOARD
      }/${selectedSubjectId}`;
      if (isOfflineFrontend && !isPalMode) {
        navigate(`/offline${route}`);
        return;
      }
      navigate(route);
    } else {
      setClickedFrom('learn');
      setModalState(true);
      try {
        if (deviceType === 'android' && android?.disableAppRefresh) {
          console.log('App refresh disabled on Android for home page');
          android.disableAppRefresh();
        }
      } catch (error) {
        console.log(
          'An error occurred while attempting to enable app refresh on Android:'
        );
      }
    }
  };

  const headerIconList: HeaderIconProps[] = [
    {
      fileName: 'teach-new',
      type: 'png',
      cardText: 'Learn',
      onClick: async () => {
        await onLearnClick();
        await interactionEvent({
          url: 'Student_Home',
          context: 'navigation_bar',
          name: 'LEARN',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
      },
      isDisabled: isPalMode && !externalStudentId,
      isHidden: session_mode === 'assess',
    },
    {
      fileName: 'assess-new',
      type: 'png',
      cardText: 'Assess',
      onClick: onHomeworkClick,
      isDisabled: isOfflineFrontend || isPalMode,
      isHidden: session_mode == 'learn',
    },
    {
      fileName: 'anlyse-new',
      type: 'png',
      cardText: 'Performance',
      onClick: onAnalyticsClick,
      isDisabled: isOfflineFrontend,
      isHidden: isPalMode,
    },
  ];

  const filteredHeaderIconList =
    currentSessionMode({ reduxSessionMode: session_mode }) === undefined
      ? headerIconList
      : headerIconList.filter((icon) => {
          const currentMode = currentSessionMode({
            reduxSessionMode: session_mode,
          });
          if (currentMode === 'learn') return icon.cardText !== 'Assess';
          if (currentMode === 'assess') return icon.cardText !== 'Learn';
          return true;
        });

  // ----------------------------------------------------

  // const showNotification = () => {
  //   Notification.requestPermission().then((result) => {
  //     if (result === 'granted') {
  //       new Notification('React Notification', {
  //         // title: 'geneo',
  //         body: 'This is a notification from your Geneo App!',
  //         // icon: 'path/to/icon.png',
  //       });
  //     }
  //   });
  // };

  // Check device type
  const deviceType = getDeviceType();

  return (
    <>
      {mobile && (
        <Box sx={{ p: `${pxToRem(20)} ${pxToRem(20)} 0` }}>
          <SecondaryButton
            witharrow={typeof selectedSubjectId === 'number' ? false : true}
            onClick={async () => {
              await interactionEvent({
                url: 'Student_Home',
                context: 'Subject_selection',
                name: 'CHOOSE_SUBJECT',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });

              setClickedFrom('header');
              setModalState(true);
              try {
                if (deviceType === 'android' && android?.disableAppRefresh) {
                  console.log('App refresh disabled on Android for home page');
                  android.disableAppRefresh();
                }
              } catch (error) {
                console.log(
                  'An error occurred while attempting to enable app refresh on Android:'
                );
              }
            }}
            // sx={{ position: 'relative', width: '100%' }}
          >
            <Typography
              variant="button"
              fontWeight="regular"
              textAlign={'left'}
              width={'100%'}
            >
              {typeof selectedSubjectId == 'number'
                ? subMap[selectedSubjectId].subjectName
                : 'Choose Subject'}
            </Typography>
            {typeof selectedSubjectId == 'number' && (
              <CloseIcon
                sx={{
                  position: 'absolute',
                  right: '10px',
                  display: 'inline-block',
                  fontSize: { xs: pxToRem(14), md: pxTovW(18) },
                }}
                onClick={async (ev) => {
                  ev.stopPropagation();
                  await aiBookCloseEvent({
                    bookId: selected_book_id,
                    isOffline: isOffline,
                  });
                  // console.log('aiBookCloseEvent - mobile');

                  dispatch(setHomeSelectedSubjectId(undefined));
                  dispatch(setHomeSelectedBookId(undefined));
                  try {
                    if (deviceType === 'android' && android?.enableAppRefresh) {
                      android.enableAppRefresh();
                      console.log(
                        'App refresh enabled on Android for home page'
                      );
                    }
                  } catch (error) {
                    console.log(
                      'An error occurred while attempting to enable app refresh on Android:'
                    );
                  }
                }}
              />
            )}
          </SecondaryButton>
        </Box>
      )}

      <Box sx={{ position: { md: 'fixed' }, width: '100vw', zIndex: 1 }}>
        {isPalFeatureEnabled && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              py: 1.5,
              borderBottom: {
                md: '0.052vw solid',
              },
              borderBottomColor: {
                md: 'neutral.grey',
              },
              background: '#FBFBFF',
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: isPalMode ? 'text.disabled' : 'text.primary',
                fontWeight: 500,
              }}
            >
              Static Mode
            </Typography>
            <Switch
              checked={isPalMode}
              onChange={() =>
                dispatch(setLearningMode(isPalMode ? 'general' : 'pal'))
              }
              sx={{
                '& .MuiSwitch-switchBase': {
                  '& .MuiSwitch-thumb': {
                    backgroundColor: '#007CDC',
                  },
                },
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: 'transparent',
                  '& .MuiSwitch-thumb': {
                    backgroundColor: 'transparent',
                    backgroundImage:
                      'url(/assets/shared-ui/icons/robotic_hand.png)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  },
                  '& + .MuiSwitch-track': {
                    backgroundColor: '#BFC8F7',
                  },
                },
                '& .MuiSwitch-track': {
                  backgroundColor: '#DBF0FF',
                  boxShadow: 'inset 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                },
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: !isPalMode ? 'text.disabled' : 'text.primary',
                fontWeight: 500,
              }}
            >
              PAL Mode
            </Typography>
          </Box>
        )}
        <HeaderIconWrapperV2
          icons={headerIconList}
          featureIconStyles={
            isPalMode
              ? {
                  background: '#DEE3FF',
                  '&:hover': {
                    background: '#DEE3FF',
                    borderColor: '#D9D9D9',
                  },
                }
              : undefined
          }
        />
        {/* <HeaderIconWrapper icons={filteredHeaderIconList} /> */}
      </Box>

      {isPalMode ? (
        <Box sx={styles.mainContainer}>
          <HomePersonalisedJourney onStartJourneyClick={onLearnClick} />
          <HomeVideoCard
            title="How to Videos"
            videos={[
              {
                title: 'Getting Started with PAL',
                duration: '3 Min',
                videoUrl:
                  'https://storage.googleapis.com/schoolnet_app_assets/how-to-videos/pal/getting-started-with-pal.mp4',
                thumbnailUrl: 'getting-started-with-pal',
              },
              {
                title: 'PAL Warm Up Test',
                duration: '5 Min',
                videoUrl:
                  'https://storage.googleapis.com/schoolnet_app_assets/how-to-videos/pal/pal-warm-up-test.mp4',
                thumbnailUrl: 'pal-warm-up-test',
              },
              {
                title: 'PAL Flow - Confident student',
                duration: '4 Min',
                videoUrl:
                  'https://storage.googleapis.com/schoolnet_app_assets/how-to-videos/pal/pal-flow-confident-student.mp4',
                thumbnailUrl: 'pal-flow-confident-student',
              },
              {
                title: 'PAL Flow - Struggling student',
                duration: '5 Min',
                videoUrl:
                  'https://storage.googleapis.com/schoolnet_app_assets/how-to-videos/pal/pal-flow-struggling-student.mp4',
                thumbnailUrl: 'pal-flow-struggling-student',
              },
            ]}
            linkButtonHandler={() => console.log('See All clicked')}
            itemsToShow={4}
            containerMdWidth="100%"
            totalNoOfItems={4}
          />
        </Box>
      ) : (
        <Box sx={styles.mainContainer}>
          {isOfflineFrontend && (
            <Box
              sx={{
                marginTop: { xs: pxToRem(-15), md: pxTovW(10) },
                marginBottom: { xs: pxToRem(10), md: pxTovW(10) },
              }}
            >
              <ConfigSelector />
            </Box>
          )}

          {!isOfflineFrontend &&
          currentSessionMode({ reduxSessionMode: session_mode }) !== 'learn' ? (
            <ActiveHomeworkList />
          ) : null}

          {!isOfflineFrontend &&
          currentSessionMode({ reduxSessionMode: session_mode }) !==
            'assess' ? (
            <OngoingLessonList />
          ) : null}

          {isWhiteLabelingFeature && (
            <Box sx={styles.logoContainer}>
              <ImageWrapper
                name="geneo-Home-logo"
                type="png"
                parentFolder="images"
                styles={styles.logo}
              />
            </Box>
          )}

          {!isOfflineFrontend &&
          currentSessionMode({ reduxSessionMode: session_mode }) !==
            'assess' ? (
            <RecommendedResourcesList />
          ) : null}

          {!isOfflineFrontend &&
          isTextBookFeatureEnabled &&
          currentSessionMode({ reduxSessionMode: session_mode }) !==
            'assess' ? (
            <TextBookList />
          ) : null}
        </Box>
      )}

      <StudentSubjectPopup
        modalState={modalState}
        setModalState={setModalState}
        displayData={filteredLearnSubjects.map((sub) => ({
          subject: sub.subjectName,
          icon: getMediaBasePath(sub.iconUrl, 'schoolnetStaticAssetBucket'),
          color: sub.textColor,
          onClick: async () => {
            dispatch(setHomeSelectedBookId(sub.bookId));
            await interactionEvent({
              url: 'Student_Home',
              context: 'Subject_selection',
              name: sub.subjectName.toUpperCase(),
              pathSegments: pathSegments,
              isOffline: isOffline,
            });

            await aiBookCloseEvent({
              bookId: selected_book_id,
              isOffline: isOffline,
            });
            // console.log('aiBookCloseEvent  - mobile');

            await aiBookOpenEvent({
              bookId: sub.bookId,
              schoolCourseId: sub.schoolCourseId,
              isOffline: isOffline,
            });

            if (clickedFrom === 'learn') {
              // dispatch(setHomeSelectedSubjectId(sub.subjectId))
              await interactionEvent({
                url: 'Student_Home',
                context: 'navigation_bar',
                name: 'LEARN',
                pathSegments: pathSegments,
                isOffline: isOffline,
              });
              const route = `${
                isPalMode ? PAL_LEARN_DASHBOARD : LEARN_DASHBOARD
              }/${sub.subjectId}`;
              if (isOfflineFrontend) {
                navigate(`/offline${route}`);
                return;
              }
              navigate(route);
            } else {
              dispatch(setHomeSelectedSubjectId(sub.subjectId));
            }

            setModalState(false);
          },
        }))}
        title="Choose Subject"
      />
      {/* <IdeathonPopup /> */}
      {/* {deviceType === 'web' && <Notification />} */}
    </>
  );
};

export default Home;
